import { Component, Input, EventEmitter, Output } from '@angular/core';
declare var $:any;

@Component({
  selector: 'other-cargoinfo',
  templateUrl: 'other-cargoinfo.html'
})
export class OhterCargoinfoComponent {
  @Input() other;

  @Input() set otherCrgoList(otherCrgoList:Array<OtherCargo>){
    if(otherCrgoList && otherCrgoList.length > 0){
      this.otherCrgo = otherCrgoList;
      this.cargoInfoChange();
    }
  }

  otherCrgo: Array<OtherCargo> = new Array( new OtherCargo());
  
  @Output() otherCargoEe: EventEmitter<any> = new EventEmitter();

  addCargo() {
    this.otherCrgo.push(new OtherCargo());
  }

  cargoInfoChange() {
    this.otherCargoEe.emit(this.otherCrgo);
  }

  pkgUnitChange(event, i) {
    this.otherCrgo[i].pkgUnit = event;
    this.otherCargoEe.emit(this.otherCrgo);
  }

  volUnitChange(event, i) {
    this.otherCrgo[i].volUnit = event;
    this.otherCargoEe.emit(this.otherCrgo);
  }
  
  weightUnitChange(event, i) {
    this.otherCrgo[i].wghtUnit = event;
    this.otherCargoEe.emit(this.otherCrgo);
  }

  delCargo(index) {
    if(this.otherCrgo.length == 1) return;
    this.otherCrgo.splice(index, 1);
    this.otherCargoEe.emit(this.otherCrgo); // 2021/05/13 견적수정 삭제버튼 시 업데이트 되지 않는 문제 수정
  }
}



export class OtherCargo {
  count: number;
  width: number;
  length: number;
  height: number;
  volUnit: string = 'cm';
  weight: number;
  wghtUnit: string = 'kg';
  pkgUnit: string;
}




// WEBPACK FOOTER //
// ./src/app/containers/quotation/consult/consult-sub/other-cargoinfo.ts